import React from "react";

import { unCamelCase } from "./../../helpers/camelCase";
import { dateFormat } from "./../../helpers/dateFormat";
import { checkNull } from "./../../helpers/checkNull";

import { TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const UneditableInput = ({ data, labels }) => {
  const history = useHistory();
  return labels.map((label) => (
    <TextField
      key={label}
      onClick={() => {
        if(label == 'userId'){
          history.push(`/users/${data[label]}`);
        }
        if(label == 'channelId' || label == 'toChannelId'){
          history.push(`/channels/searchItem=id&search=${data[label]}`);
        }
      }}
      InputLabelProps={{ shrink: true }}
      label={unCamelCase(label)}
      value={checkNull(label !== ('id'||'isMember') ? dateFormat(data[label]) : data[label])}
      disabled
    />
  ));
};

export default UneditableInput;
